<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'approval.summary'">
    <htx-button variant="tertiary" icon="arrow_back" (click)="backToList()">{{
      'button.back' | transloco
    }}</htx-button>
    @if (changeRequest$ | async; as changeRequest) {
      <div class="panel">
        <htx-data-display
          [title]="t('organisationDetails')"
          [icon]="'business'"
          [data]="(organisationDetails$ | async) ?? []"
        ></htx-data-display>

        <div class="details-grid">
          <htx-data-display
            [title]="'representativeChange.detail.oldRepresentative' | transloco"
            [icon]="'person'"
            [data]="(oldRepresentativeDetails$ | async)!"
          ></htx-data-display>
          <htx-data-display
            [title]="'representativeChange.detail.newRepresentative' | transloco"
            [icon]="'person_add'"
            [data]="(newRepresentativeDetails$ | async)!"
          ></htx-data-display>
        </div>

        <div class="details-grid">
          <htx-data-container [title]="'representativeChange.detail.changeInfo' | transloco" [icon]="'swap_horiz'">
            <div class="change-info">
              <div class="info-field">
                <span class="info-label">{{ 'representativeChange.detail.reasoning' | transloco }}</span>
                <p class="info-value">{{ changeRequest.reasoning || '-' }}</p>
              </div>
              <div class="info-field">
                <span class="info-label">{{ 'representativeChange.detail.requestDate' | transloco }}</span>
                <p class="info-value">{{ changeRequest.createdDate ? (changeRequest.createdDate | date:'dd.MM.yyyy') : '-' }}</p>
              </div>
            </div>
          </htx-data-container>

          <htx-data-container [title]="t('document')" [icon]="'description'">
            <div class="document-section">
              <htx-button variant="secondary" icon="visibility" (click)="viewDocument()">
                {{ 'representativeChange.detail.viewDocument' | transloco }}
              </htx-button>
            </div>
          </htx-data-container>
        </div>

        <htx-data-container [title]="t('decision')" [icon]="'done_all'">
          <app-admission-decision
            [approvalForm]="approvalForm"
            [admissionState$]="admissionState$"
            [existingReasoning$]="existingReasoning$"
            (approve)="approve()"
            (reject)="reject()"
          ></app-admission-decision>
        </htx-data-container>

        <htx-data-container [title]="t('comments')" [icon]="'chat'">
          @if (commentsForBox$ | async; as commentsForBox) {
            <app-comments
              [comments]="commentsForBox"
              [placeholder]="t('newComment.placeholder')"
              (commentAdded)="onCommentAdded($event)"
            ></app-comments>
          }
        </htx-data-container>
      </div>
    }
  </div>
</app-protected-content>
